<template>
  <KTTable
    title="Forma Jurídica"
    subtitle="Lista de Forma Jurídica"
    :fields="fields"
    :items="$store.state.formaJuridica.formasJuridicas"
    @delete="deleteItem($event)"
  ></KTTable>
</template>

<script>
import KTTable from "@/view/content/Table.vue";
import { DELETE_FORMA_JURIDICA } from "@/core/services/store/formaJuridica.module";

export default {
  name: "dashboard",
  components: { KTTable },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "Id Forma Jurídica",
          sortable: true
        },
        {
          key: "codigo",
          label: "FJ",
          sortable: true
        },
        {
          key: "sex",
          label: "Sexo",
          sortable: true
        },
        {
          key: "letterCIF",
          label: "Letra CIF",
          sortable: true
        },
        {
          key: "literal",
          label: "Lieral Forma Jurídica",
          sortable: true
        },
        {
          key: "actions",
          label: ""
        }
      ]
    };
  },
  methods: {
    deleteItem(item) {
      this.$store.commit(DELETE_FORMA_JURIDICA, item);
    }
  }
};
</script>
